<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <material-card
          color="green"
          :title="$t('Assessments.tableHeading')"
          :text="$t('Assessments.tableDescription')"
        >
          <v-data-table
            :headers="headers"
            :items="reportMetrics"
            :loading="isLoading"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-row>
                  <v-col cols="12">
                    <v-btn
                      :id="`automation-id-Assessments-btn-new`"
                      elevation-4
                      light
                      color="green darken-2"
                      @click="$router.push({ name: 'Edit Assessment', params: { id: assessmentId } })"
                      class="white--text"
                    >
                      <v-icon class="mr-4">
                        mdi-pencil
                      </v-icon>
                      {{ $t('Assessments.editButton')}}
                    </v-btn>
                    <v-btn
                      :id="`automation-id-Assessments-btn-refresh`"
                      @click="refresh()"
                      text
                      icon
                      color="green"
                      class="float-right">
                      <v-icon>mdi-cached</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-toolbar>
            </template>
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text-success text--darken-3"
                v-text="header.text"
              />
            </template>
            <template v-slot:item.created="{ item }">
              <span v-text="new Date(item.created).toLocaleDateString(undefined, { dateStyle: 'long' })" />
            </template>
            <template v-slot:item.isCompleted="{ item }">
              <aurora-bool-field :boolValue="item.isCompleted">
                <template v-slot:true>
                  Yes
                </template>
                <template v-slot:false>
                  No
                </template>
              </aurora-bool-field>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'AssessmentItems',
  data: () => ({
    headers: [
      {
        sortable: true,
        text: 'Metric',
        value: 'metric.metricTab.name',
      },
      {
        sortable: true,
        text: 'Question',
        value: 'metric.name',
      },
      {
        sortable: true,
        text: 'Question',
        value: 'metric.name',
      },
      {
        sortable: true,
        text: 'Details',
        value: 'metric.details',
      },
      {
        sortable: true,
        text: 'Total Response',
        value: 'totalResponse',
      },
      {
        sortable: true,
        text: 'Total Success',
        value: 'totalSuccess',
      },
    ],
    isLoading: false,
  }),
  computed: {
    ...mapState('assessments', ['reportMetrics']),
    assessmentId() {
      return this?.$route?.query.assessmentId;
    },
  },
  mounted() {
    this.refresh();
  },
  methods: {
    ...mapActions('assessments', ['loadReportMetrics']),
    editAssessment(item) {
      this.$router.push({ name: 'Edit Assessment', params: { id: item.id } });
    },
    async refresh() {
      this.isLoading = true;
      await this.loadReportMetrics(this.assessmentId);
      this.isLoading = false;
    },
  },
};
</script>
